import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  ForwardRefRenderFunction,
} from 'react';
import {
  Switch as MUISwitch,
  SwitchProps as MUISwitchProps,
} from '@mui/material';

interface SwitchProps extends MUISwitchProps {
  value?: boolean;
  disabled?: boolean;
  isDisabled?: boolean;
  handleOnChange?: () => void;
}
export interface SwitchRef {
  isChecked: boolean;
  handleDisable: (isDisabled: boolean) => void;
  handleCheckSwitch: (isChecked: boolean) => void;
}

const Switch: ForwardRefRenderFunction<SwitchRef, SwitchProps> = (
  { value = false, disabled = false, handleOnChange, className, ...rest },
  ref
) => {
  const [isChecked, setIsChecked] = useState<boolean>(value ?? false);
  const [isDisabled, setIsDisabled] = useState<boolean>(false);

  const handleCheckSwitch = (isChecked: boolean) => setIsChecked(isChecked);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (isDisabled == false) {
      setIsChecked(event.target.checked);
    }
    if (handleOnChange) handleOnChange();
  };
  const handleDisable = (isDisabled: boolean) => setIsDisabled(isDisabled);

  useImperativeHandle(ref, () => ({
    isChecked,
    handleCheckSwitch,
    handleDisable,
  }));

  useEffect(() => {
    if (disabled != isDisabled) {
      setIsDisabled(disabled);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disabled]);

  useEffect(() => {
    if (value != isChecked) {
      setIsChecked(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <MUISwitch
      checked={isChecked}
      {...rest}
      onChange={handleChange}
      className={isDisabled ? `disabled-switch` : className}
    />
  );
};

export default forwardRef<SwitchRef, SwitchProps>(Switch);
